<h1 mat-dialog-title class="title text-hard-blue">Abrir Ordem de Serviço</h1>
<div mat-dialog-content style="overflow: hidden;">
  <mat-form-field fxFill appearance="outline">
    <mat-select [(ngModel)]="technician">
      <mat-option *ngFor="let user of users" [value]="user.id">{{user.name}}</mat-option>
    </mat-select>
    <mat-label>Técnico responsável</mat-label>
  </mat-form-field>

  <button
    style="margin-bottom: 15px;"
    [disabled]="saving"
    mat-raised-button
    color="basic"
    (click)="copyCallText()"
  >Copiar Texto do Chamado</button>

  <div>
    <ckeditor
      fxFill
      [config]="{
        toolbar: [
          'heading',
          '|',
          'bold',
          'italic',
          '|',
          'bulletedList',
          'numberedList',
          '|',
          'undo',
          'redo'
        ]
      }"
      [editor]="entryEditor"
      [(ngModel)]="description"
    ></ckeditor>
  </div>

  <div *ngIf="os != null">
    <h4 class="text-green">Ordem de serviço Criado com sucesso!</h4>
    <h5>Ordem de serviço: {{ os.number }}</h5>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button [disabled]="saving" mat-raised-button color="warn" mat-dialog-close>Fechar</button>
  <button [disabled]="saving" mat-raised-button color="primary" (click)="createOs()">Abrir Ordem de Serviço</button>
</div>
